import Quill from 'quill'
import 'quill/dist/quill.snow.css'
/* global $:false,toastr:false  */
;(function () {
  'use strict'

  angular
    .module('pub.collectibles.edition', [])
    .controller('CollectiblesEditionCtrl', CollectiblesEditionCtrl)

  /** @ngInject */
  function CollectiblesEditionCtrl(
    $scope,
    $timeout,
    $q,
    $sce,
    $rootScope,
    $location,
    $state,
    $stateParams,
    CollectiblesService,
    SetsService,
    UploadService,
    TranslatorService,
    TagsService,
  ) {
    var vm = this
    vm.isOpen = false
    vm.model = {}
    vm.collectibles = []
    vm.pathImgL = ''
    vm.pathImgBackL = ''
    vm.pathImgT = ''
    vm.imagesToDelete = []
    vm.pathScreen = ''
    vm.loadT = false
    vm.loadL = false
    vm.loadBackL = false
    vm.isUpload = true
    vm.awaitingCount = false
    vm.waitCategory = true
    vm.todo = {
      t: false,
      txt: false,
      edition: false,
      print: false,
      header: false,
      thumbnail: false,
      tags: false,
    }
    vm.tags = []
    vm.tagsList = []
    vm.title = null
    vm.status = null
    vm.modelTypes = [
      { id: 0, t: 'Collectible' },
      { id: 1, t: 'Sandbox' },
    ]
    vm.renderTypes = [
      { id: 0, t: 'Basic' },
      { id: 1, t: 'White' },
      { id: 2, t: 'Red' },
      { id: 3, t: 'Gold' },
      { id: 4, t: 'Purple' },
      { id: 5, t: 'Metal' },
    ]
    vm.model['k-render'] = 0

    const toolbarOptions = {
      container: [
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        ['blockquote', 'code-block'],

        [{ list: 'ordered' }, { list: 'bullet' }],

        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ['clean'], // remove formatting button

        ['link'], // link and image, video
        [{ align: [] }],
      ],
    }

    const options = {
      modules: {
        toolbar: toolbarOptions,
      },
      placeholder: 'Write something...',
      theme: 'snow',
    }
    const editor = new Quill('.editor', options)

    $rootScope.$on('tagsList', function (event, data) {
      if (vm.tagsList) {
        data.map(function (item) {
          vm.tagsList.push(item)
        })
        vm.tagsList = _.uniqBy(vm.tagsList, 'id')
      } else {
        vm.tagsList = data
      }
    })

    SetsService.getId($stateParams.parentId).then(function (result) {
      vm.set = result.results
      vm.glossaryName = vm.set.ch['id-gl']
      vm.isSticker = false
      if (vm.set['k-prod'] === 3) {
        vm.isFigurine = true
        vm.nameType = 'Figure'
      } else if (vm.set['k-prod'] === 2) {
        vm.isFigurine = false
        vm.isSticker = false
        vm.nameType = 'Card'
      }
      //  else if (vm.set['k-prod'] === 1) {
      //   vm.isFigurine = false
      //   vm.isSticker = true
      //   vm.nameType = 'Sticker'
      //   vm.model.kbd = true
      // }
      else {
        vm.isFigurine = false
        vm.isSticker = false
        vm.nameType = 'Card'
      }
    })

    vm.listProductTypes = [
      // { id: 1, t: 'Sticker' },
      { id: 2, t: 'Card' },
      { id: 3, t: 'Figure' },
    ]

    vm.collectiblesTranslations = []
    function loadTranslations() {
      CollectiblesService.listTranslations($stateParams.id).then(function (result) {
        vm.collectiblesTranslations = result.results
      })
    }

    loadTranslations()

    vm.back = function () {
      $state.go('pub.collectibles', { parentId: $stateParams.parentId })
    }

    vm.next = function () {
      $state.go('pub.collectibles', { parentId: $stateParams.parentId })
    }

    var edit = $location.$$path.indexOf('edit') !== -1
    if (edit) {
      vm.model.id = $stateParams.id
      if (vm.model.id !== 0 && vm.model.id !== undefined && vm.model.id !== null) {
        CollectiblesService.getId($stateParams.parentId, vm.model.id).then(function (result) {
          var collectible = result.results
          vm.model.t = collectible.t
          vm.title = collectible.t
          vm.description = collectible.txt
          vm.model.txt = collectible.txt
          editor.clipboard.dangerouslyPasteHTML(collectible.txt || '')
          vm.model.em = collectible.em
          vm.model.obj = collectible.obj
          vm.model.bc = collectible.bc
          vm.model.pt = collectible.pt
          vm.model.sf = collectible.sf
          vm.model.kbd = collectible.kbd
          vm.model.own = collectible.own
          vm.model.e = collectible.e
          vm.model['k-render'] = collectible['k-render']
          vm.model.mint = collectible.mint
          vm.model.redeem = collectible.redeem
          vm.model.sho = collectible.sho
          vm.model.pfp = collectible.pfp
          if (vm.model.sf === 0) {
            vm.model.sf = 1
          }
          vm.model.crs = collectible.crs
          vm.model['k-prod'] = collectible['k-prod']
          vm.model['img-l'] = collectible['img-l']
          vm.model['img-b-l'] = collectible['img-b-l']
          vm.model['img-t'] = collectible['img-t']
          vm.model['k-mod'] = collectible['k-mod']
          vm.model.qmf = collectible.qmf
          vm.model.st = collectible.st
          vm.files3 = collectible.qmf
          vm.pathImgL = collectible['img-l']
          vm.pathImgBackL = collectible['img-b-l']
          vm.pathImgT = collectible['img-t']
          vm.isUpload = false
          vm.model.tags = collectible.tags
          if (vm.model.tags !== undefined) {
            for (var i = 0; i < vm.model.tags.length; i++) {
              vm.tags.push(vm.model.tags[i].id)
            }
          }

          vm.status = collectible.st
          if (collectible.st === 4) {
            vm.awaitingCount = true
          }

          $('#e7').select2('data', vm.model.tags)
          vm.todo.t = collectible.t !== ''
          vm.todo.txt = collectible.txt !== ''
          vm.todo.edition = collectible.e !== 0
          vm.todo.print = collectible.bc !== 0
          vm.todo.header = collectible['img-l'] !== ''
          vm.todo.thumbnail = collectible['img-t'] !== ''
          vm.todo.tags = vm.tags.length > 0

          CollectiblesService.listProductCategories().then(function (result) {
            vm.productCategories = result.results
            if (collectible['p-sc']) {
              vm.productCategory = vm.productCategories.find(
                (item) => item.id === collectible['p-sc']['id-p-cat'],
              ).id
              vm.productSubCategory = collectible['id-p-sc']
              vm.loadSubCategories(vm.productCategory)
            }
          })
        })

        CollectiblesService.getNumPrintsActiveUsers(vm.model.id).then(function (result) {
          vm.model.cpo = result.results.cpo
        })
      }
    }

    // var makeTranslation = function (t, txt, currentTranslations, paramsId, route) {
    //   if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
    //     if (vm.title === t && vm.description === txt) {
    //       return
    //     }
    //   }

    //   TranslatorService.translateProductAllLanguage(t, txt, vm.glossaryName).then(function (res) {
    //     var languages = ['ja', 'ko', 'zh', 'zh-TW']

    //     for (var i = 0; i < currentTranslations.length; i++) {
    //       for (var key in res.t.results) {
    //         if (currentTranslations[i].comm === 'JP' && key.indexOf('ja') !== -1) {
    //           languages.remove('ja')
    //         }
    //         if (currentTranslations[i].comm === 'KR' && key.indexOf('ko') !== -1) {
    //           languages.remove('ko')
    //         }
    //         if (currentTranslations[i].comm === 'SC' && key.indexOf('zh') !== -1) {
    //           languages.remove('zh')
    //         }
    //         if (currentTranslations[i].comm === 'TC' && key.indexOf('zh-TW') !== -1) {
    //           languages.remove('zh-TW')
    //         }
    //       }
    //     }

    //     if (vm.model.id !== undefined && vm.model.id !== '' && vm.model.id !== 0) {
    //       var promises = []

    //       for (var i = 0; i < currentTranslations.length; i++) {
    //         // if (currentTranslations[i]['id-u']) {
    //         //   continue
    //         // }
    //         if (currentTranslations[i].comm === 'SC' && res.t.results) {
    //           var exist = _.find(languages, 'zh')
    //           if (exist) {
    //             promises.push(
    //               CollectiblesService.createTranslation(paramsId, {
    //                 'id-u': 0,
    //                 comm: 'SC',
    //                 t: res.t.results.zh,
    //                 txt: res.txt.results.zh,
    //               }),
    //             )
    //           } else {
    //             promises.push(
    //               CollectiblesService.updateTranslation(currentTranslations[i].id, {
    //                 'id-u': 0,
    //                 t: res.t.results.zh,
    //                 txt: res.txt.results.zh,
    //               }),
    //             )
    //           }
    //           continue
    //         }
    //         if (currentTranslations[i].comm === 'TC' && res.t.results) {
    //           var exist = _.find(languages, 'zh-TW')
    //           if (exist) {
    //             promises.push(
    //               CollectiblesService.createTranslation(paramsId, {
    //                 'id-u': 0,
    //                 comm: 'TC',
    //                 t: res.t.results['zh-TW'],
    //                 txt: res.txt.results['zh-TW'],
    //               }),
    //             )
    //           } else {
    //             promises.push(
    //               CollectiblesService.updateTranslation(currentTranslations[i].id, {
    //                 'id-u': 0,
    //                 t: res.t.results['zh-TW'],
    //                 txt: res.txt.results['zh-TW'],
    //               }),
    //             )
    //           }
    //           continue
    //         }
    //         if (currentTranslations[i].comm === 'KR' && res.t.results) {
    //           var exist = _.find(languages, 'ko')
    //           if (exist) {
    //             promises.push(
    //               CollectiblesService.createTranslation(paramsId, {
    //                 'id-u': 0,
    //                 comm: 'KR',
    //                 t: res.t.results.ko,
    //                 txt: res.txt.results.ko,
    //               }),
    //             )
    //           } else {
    //             promises.push(
    //               CollectiblesService.updateTranslation(currentTranslations[i].id, {
    //                 'id-u': 0,
    //                 t: res.t.results.ko,
    //                 txt: res.txt.results.ko,
    //               }),
    //             )
    //           }
    //           continue
    //         }
    //         if (currentTranslations[i].comm === 'JP' && res.t.results) {
    //           var exist = _.find(languages, 'ja')
    //           if (exist) {
    //             promises.push(
    //               CollectiblesService.createTranslation(paramsId, {
    //                 'id-u': 0,
    //                 comm: 'JP',
    //                 t: res.t.results.ja,
    //                 txt: res.txt.results.ja,
    //               }),
    //             )
    //           } else {
    //             promises.push(
    //               CollectiblesService.updateTranslation(currentTranslations[i].id, {
    //                 'id-u': 0,
    //                 t: res.t.results.ja,
    //                 txt: res.txt.results.ja,
    //               }),
    //             )
    //           }
    //           continue
    //         }
    //       }

    //       $q.all(promises)
    //         .then(function () {
    //           $state.go(route, { parentId: $stateParams.parentId })
    //         })
    //         .catch(function (err) {
    //           swal('Error in translation, please send message to qp2 administrator!', '', 'error')
    //         })
    //     }

    //     var promises = []

    //     for (var i = 0; i < languages.length; i++) {
    //       if (languages[i] === 'zh' && res.t.results) {
    //         promises.push(
    //           CollectiblesService.createTranslation(paramsId, {
    //             'id-u': 0,
    //             comm: 'SC',
    //             t: res.t.results.zh,
    //             txt: res.txt.results.zh,
    //           }),
    //         )
    //       }
    //       if (languages[i] === 'zh-TW' && res.t.results) {
    //         promises.push(
    //           CollectiblesService.createTranslation(paramsId, {
    //             'id-u': 0,
    //             comm: 'TC',
    //             t: res.t.results['zh-TW'],
    //             txt: res.txt.results['zh-TW'],
    //           }),
    //         )
    //       }
    //       if (languages[i] === 'ko' && res.t.results) {
    //         promises.push(
    //           CollectiblesService.createTranslation(paramsId, {
    //             'id-u': 0,
    //             comm: 'KR',
    //             t: res.t.results.ko,
    //             txt: res.txt.results.ko,
    //           }),
    //         )
    //       }
    //       if (languages[i] === 'ja' && res.t.results) {
    //         promises.push(
    //           CollectiblesService.createTranslation(paramsId, {
    //             'id-u': 0,
    //             comm: 'JP',
    //             t: res.t.results.ja,
    //             txt: res.txt.results.ja,
    //           }),
    //         )
    //       }
    //     }

    //     $q.all(promises)
    //       .then(function () {})
    //       .catch(function () {
    //         swal('Error in translation, please send message to qp2 administrator!', '', 'error')
    //       })
    //   })
    // }

    vm.save = function (options, isValid) {
      if (!isValid) {
        toastr.warning('Complete all fields!')
        return
      }

      var listTags = $('#e7').select2('val')
      var modelTags = []
      if (listTags !== undefined) {
        if (vm.model.tags !== undefined) {
          for (var i = 0; i < vm.model.tags.length; i++) {
            for (var j = 0; j < listTags.length; j++) {
              if (parseInt(listTags[j]) === vm.model.tags[i].id) {
                modelTags.push(vm.model.tags[i])
              }
            }
          }
        }

        for (var i = 0; i < vm.tagsList.length; i++) {
          for (var j = 0; j < listTags.length; j++) {
            if (parseInt(listTags[j]) === vm.tagsList[i].id) {
              modelTags.push(vm.tagsList[i])
            }
          }
        }
      }

      vm.model.txt = editor.root.innerHTML
      if (editor.root.innerHTML === '<p><br></p>') {
        vm.model.txt = ''
      }

      vm.todo.t = vm.model.t !== ''
      vm.todo.txt = vm.model.txt !== ''
      vm.todo.edition = vm.model.e !== 0
      vm.todo.print = vm.model.bc !== 0
      vm.todo.header = vm.model['img-l'] !== ''
      vm.todo.thumbnail = vm.model['img-t'] !== ''
      vm.todo.tags = modelTags.length > 0
      vm.model.id = parseInt(vm.model.id)

      if (vm.model.sf > 1.0 || vm.model.sf < 0.25) {
        toastr.warning('Scale Factor need to be set between 0.25 - 1.0')
        return
      }

      if (vm.model.crs > 0.5 || vm.model.crs < 0.0) {
        toastr.warning('Corner Radius need to be set between 0.0 - 0.5')
        return
      }

      if (vm.model.e === 0) {
        vm.model.e = 1
      }

      if (vm.set['k-prod'] === 3) {
        vm.model['img-l'] = ''
        vm.model['img-b-l'] = ''
      } else if (vm.set['k-prod'] === 2) {
        vm.model['qmf'] = ''
      }
      //  else if (vm.set['k-prod'] === 1) {
      //   vm.model['img-b-l'] = ''
      //   vm.model['qmf'] = ''
      // }

      if (vm.awaitingCount) {
        vm.model.st = 4
      } else {
        if (vm.status === 4) {
          vm.model.st = 0
        }
      }

      if (vm.productSubCategory) {
        vm.model['id-p-sc'] = vm.productSubCategory
      }

      vm.model['img-qmf'] = vm.files3
      delete vm.model.qmf

      if (vm.model.id !== 0 && vm.model.id !== undefined && vm.model.id !== null) {
        delete vm.model.pt
        CollectiblesService.update($stateParams.parentId, vm.model.id, vm.model).then(function () {
          TagsService.addTagCollectible(vm.model.id, modelTags).then(function () {
            angular.forEach(vm.imagesToDelete, function (oldPath) {
              UploadService.deleteFile('collectibles', oldPath)
            })
            toastr.success('Saved.')
            // makeTranslation(
            //   vm.model.t,
            //   vm.model.txt,
            //   vm.collectiblesTranslations,
            //   vm.model.id,
            //   'pub.collectibles',
            // )
            $state.go('pub.collectibles', { parentId: $stateParams.parentId })
          })
        })
      } else {
        CollectiblesService.save($stateParams.parentId, vm.model).then(function (result) {
          TagsService.addTagCollectible(result.results.id, modelTags).then(function () {
            angular.forEach(vm.imagesToDelete, function (oldPath) {
              UploadService.deleteFile('collectibles', oldPath)
            })
            toastr.success('Saved. Now you can add images')
            vm.model.id = result.results.id
            vm.isUpload = false
            // makeTranslation(
            //   vm.model.t,
            //   vm.model.txt,
            //   vm.collectiblesTranslations,
            //   result.results.id,
            //   'pub.collectibles',
            // )
            $state.go('pub.collectibles', { parentId: $stateParams.parentId })
          })
        })
      }
    }

    vm.own = function (id) {
      if (vm.model.own === true) {
        CollectiblesService.owned(id).then(function () {})
      } else {
        CollectiblesService.disown(id).then(function () {})
      }
    }

    var watch = $scope.$watch('vm.fileImgT', function (newVal, oldVal) {
      if (newVal === oldVal) {
        vm.loadT = false
        return
      }

      if (newVal === null) {
        vm.loadT = false
      }

      vm.loadT = true
      var oldPath = vm.pathImgT
      UploadService.save('collectibles', newVal, 'img-t', vm.model.id).then(function (fileName) {
        vm.loadT = false
        vm.model['img-t'] = fileName
        vm.pathImgT = fileName
        if (oldPath) {
          vm.imagesToDelete.push(oldPath)
        }
      })
    })

    var watch1 = $scope.$watch('vm.fileImgL', function (newVal, oldVal) {
      if (newVal === oldVal) {
        vm.loadL = false
        return
      }

      if (newVal === null) {
        vm.loadL = false
      }

      vm.loadL = true
      var oldPath = vm.pathImgL
      UploadService.save('collectibles', newVal, 'img-l', vm.model.id).then(function (fileName) {
        vm.loadL = false
        vm.model['img-l'] = fileName
        vm.pathImgL = fileName
        if (oldPath) {
          vm.imagesToDelete.push(oldPath)
        }
      })
    })

    var watch2 = $scope.$watch('vm.fileImgBackL', function (newVal, oldVal) {
      if (newVal === oldVal) {
        vm.loadBackL = false
        return
      }

      if (newVal === null) {
        vm.loadBackL = false
      }

      vm.loadBackL = true
      var oldPath = vm.pathImgBackL
      UploadService.save('collectibles', newVal, 'img-b-l', vm.model.id).then(function (fileName) {
        vm.loadBackL = false
        vm.model['img-b-l'] = fileName
        vm.pathImgBackL = fileName
        if (oldPath) {
          vm.imagesToDelete.push(oldPath)
        }
      })
    })

    //QMF logic
    var watch3 = $scope.$watch('vm.qmfFile', function (newVal, oldVal) {
      if (newVal === oldVal) {
        return
      }

      vm.model.id = parseInt(vm.model.id)

      if (vm.model.id !== 0 && vm.model.id !== undefined && vm.model.id !== null) {
        delete vm.model.pt
        if (vm.model.e === 0) {
          vm.model.e = 1
        }
        var modelTags = []
        for (var i = 0; i < vm.tagsList.length; i++) {
          for (var j = 0; j < vm.tags.length; j++) {
            if (vm.tags[j] === vm.tagsList[i].id) {
              modelTags.push(vm.tagsList[i])
            }
          }
        }
        var nameFile = newVal.name.split('.')[0]
        var fileNameZip =
          nameFile + '-' + $stateParams.id + '-' + new Date().getTime() + '.' + 'zip'
        vm.model.qmf = fileNameZip
        CollectiblesService.update($stateParams.parentId, vm.model.id, vm.model).then(function () {
          TagsService.addTagCollectible(vm.model.id, modelTags).then(function () {})
        })
      }

      UploadService.saveQmf('collectibles', newVal, '', $stateParams.id).then(function (file) {
        vm.files3 = file
        // vm.model.qmf = file;
        toastr.success('Process complete!')
      })
    })

    //Obj Data logic
    vm.loadingObj = false
    vm.newUploadObj = false
    var watch4 = $scope.$watch('vm.objDataFile', function (newVal, oldVal) {
      if (!newVal) {
        vm.loadingObj = false
        return
      }
      if (newVal === oldVal) {
        vm.loadingObj = false
        return
      }

      vm.loadingObj = true

      UploadService.save('collectibles', newVal, 'obj-data', vm.model.id).then(
        function (fileName) {
          vm.model.obj = fileName
          vm.loadingObj = false
          vm.newUploadObj = true
          toastr.success('Upload complete!')
        },
        function (err) {
          $timeout(function () {
            swal(err.error.message, '', 'error')
          }, 200)
          vm.loadingObj = true
        },
      )
    })

    vm.glbProgress = 0
    $rootScope.$on('uploadProgress', function (event, data) {
      vm.glbProgress = data
      $scope.$apply()
    })

    var watchVideoL = $scope.$watch('vm.pathImgL', function (newVal) {
      if (newVal && (newVal.indexOf('.mp4') !== -1 || newVal.indexOf('.mov') !== -1)) {
        vm.isVideoL = true
        vm.videoL = $sce.trustAsResourceUrl($rootScope.urlS3 + '/collectibles/' + newVal)
      } else {
        vm.isVideoL = false
        vm.videoL = ''
      }
    })

    var watchVideoBackL = $scope.$watch('vm.pathImgBackL', function (newVal) {
      if (newVal && (newVal.indexOf('.mp4') !== -1 || newVal.indexOf('.mov') !== -1)) {
        vm.isVideoBackL = true
        vm.videoBackL = $sce.trustAsResourceUrl($rootScope.urlS3 + '/collectibles/' + newVal)
      } else {
        vm.isVideoBackL = false
        vm.videoBackL = ''
      }
    })

    var watchVideoT = $scope.$watch('vm.pathImgT', function (newVal) {
      if (newVal && (newVal.indexOf('.mp4') !== -1 || newVal.indexOf('.mov') !== -1)) {
        vm.isVideoT = true
        vm.videoT = $sce.trustAsResourceUrl($rootScope.urlS3 + '/collectibles/' + newVal)
      } else {
        vm.isVideoT = false
        vm.videoT = ''
      }
    })

    $scope.$on('$destroy', function () {
      watch()
      watch1()
      watch2()
      watch3()
      watch4()
      watchVideoL()
      watchVideoBackL()
      watchVideoT()
    })

    vm.deleteImage = function (key) {
      var oldPath = ''
      switch (key) {
        case 'img-l':
          oldPath = vm.pathImgL
          vm.pathImgL = ''
          break
        case 'img-b-l':
          oldPath = vm.pathImgBackL
          vm.pathImgBackL = ''
          break
        case 'img-t':
          oldPath = vm.pathImgT
          vm.pathImgT = ''
          break
      }
      vm.model[key] = ''
      if (oldPath) {
        vm.imagesToDelete.push(oldPath)
      }
    }

    vm.productCategory = null
    vm.productCategories = []
    vm.productSubCategory = null
    vm.productSubCategories = []

    vm.loadSubCategories = function (id) {
      CollectiblesService.listProductSubCategories(id, 0, 100).then(function (result) {
        vm.productSubCategories = result.results
        vm.waitCategory = false
      })
    }
  }
})()
